<template>
  <div class="common-table-list systemManage-user-group">
    <div class="location">
      <router-link style="color: #6e6b7b" to="/">{{
        $t("Welcome")
      }}</router-link>
      <span> > {{ $t("System Management") }} > </span>
      <span style="color: #3461ff">{{ $t("Menu") }}</span>
    </div>
    <div class="hd card">
      <div class="handle-button-section">
        <el-button type="primary" size="small" @click="handleAdd">
          <i class="el-icon-plus" />
          {{ $t("MenuConfig.Add") }}
        </el-button>
      </div>
    </div>

    <div class="bd card">
      <!-- 表格 -->
      <el-table
        :data="menuList"
        style="width: 100%"
        table-layout="fixed"
        v-loading="loading"
        ref="normalTable"
        row-key="menuId"
        default-expand-all
        :tree-props="{ children: 'childMenu', hasChildren: 'hasChildren' }"
      >
        >
        <el-table-column
          :label="$t('MenuConfig.Menu Name')"
          prop="name"
          min-width="240"
          align="left"
        >
        </el-table-column>
        <el-table-column
          :label="$t('MenuConfig.Menu Icon')"
          prop="iconUrl"
          min-width="100"
          align="center"
        >
          <template slot-scope="{ row }">
            <feather-icon :icon="row.iconUrl" size="21" />
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('MenuConfig.Menu Sort')"
          min-width="80"
          prop="sort"
          align="center"
        >
        </el-table-column>
        <el-table-column
          :label="$t('MenuConfig.Menu Type')"
          min-width="100"
          prop="nodeType"
        >
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.nodeType == 0">
              {{ $t("MenuConfig.Menu Type0") }}
            </el-tag>
            <el-tag size="small" type="success" v-if="row.nodeType == 1">
              {{ $t("MenuConfig.Menu Type1") }}
            </el-tag>
            <el-tag size="small" type="danger"  v-if="row.nodeType == 2">{{
              $t("MenuConfig.Menu Type2")
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('MenuConfig.Menu Code')"
          min-width="200"
          prop="menuCode"
        >
        </el-table-column>
        <el-table-column
          :label="$t('MenuConfig.Menu Path')"
          min-width="160"
          prop="path"
        >
        </el-table-column>
        <el-table-column
          :label="$t('MenuConfig.UpdateTime')"
          min-width="230"
          prop="updateTime"
          align="center"
        >
        </el-table-column>

        <el-table-column
          fixed="right"
          :label="$t('userGroup.Action')"
          width="110"
          align="center"
        >
          <template slot="default" slot-scope="{ row }">
            <div class="operate">
              <span class="table-icon" @click="handleEdit(row)">
                <i class="el-icon-edit-outline"></i>
              </span>
              <span class="table-icon" @click="handleDelete(row)">
                <i class="el-icon-delete"></i>
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 创建用户组 -->
    <createMenu
      ref="createMenuRef"
      :editData="editData"
      :menuList="menuList"
      @getData="getAllMenuList"
    >
    </createMenu>

    <!-- 删除弹窗确认 -->
    <deleteConfirmDialog
      ref="deleteConfirmDialog"
      @onDeleteConfirm="menuDelete"
    ></deleteConfirmDialog>
  </div>
</template>
<script>
import {
  getMenuTree,
  physicalDeleteMenu,
  getRoleMenuList,
} from "@/libs/api/menu";

import createMenu from "./components/createMenu";
import { commonStore } from "@/store/global-select-store";
import deleteConfirmDialog from "@/components/delete-confirm-dialog/index";

export default {
  name: "userGroup",
  components: {
    createMenu,
    deleteConfirmDialog,
  },
  props: {
    location: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {
      menuTreeData: {},
      menuList: [],
      commonStore,
      userData: JSON.parse(localStorage.getItem("userData")),
      editData: {},
      loading: false,
      searchParams: {
        storeId: "", // 门店id
        roleName: "", // 角色名称
        isEffect: 0, // 是否有效，0：有效，1：无效
        storeName: "", // 门店名称
        storeQueryType: "0", //门店查询类型 ,0：所有门店，1：子门店，2：当前门店
        startCreateTime: "", // 创建时间 起始时间
        endCreateTime: "", // 创建时间 结束时间
        startUpdateTime: "", // 更新时间 起始时间
        endUpdateTime: "", // 更新时间 结束时间
        orders: [], //用于排序的字段，允许多组，以JSONArray格式保存,['desc:tagIdentity']
        updateDate: ["", ""], //更新时间
        createDate: ["", ""], // 创建时间
      },
      pageParams: {
        current: 1, //当前页
        size: 10, //单页显示最大数
        total: 0,
        pageSizeArr: ["10", "20", "50", "100", "200", "500", "1000"],
      },
    };
  },
  created() {},
  mounted() {
    this.getAllMenuList();
  },
  methods: {
    getAllMenuList() {
      let userData = JSON.parse(localStorage.getItem("userData"));
      console.log(userData);
      this.menuList = []
      const params = {
        roleId: userData.userRoleId,
      };
      getMenuTree(params).then((res) => {
        console.log(res);

        this.menuList = res.data.data;
      });
      getRoleMenuList().then((res) => {
        console.log(res);
      });
    },

    // 时间选择范围变更---创建时间
    handleCreateTimeChange(val) {
      let searchParams = {
        ...this.searchParams,
      };
      if (!val) {
        searchParams.createDate = ["", ""];
      }
      this.searchParams = searchParams;
      this.getAllMenuList();
    },
    // 时间选择范围变更---更新时间
    handleUpdateTimeChange(val) {
      let searchParams = {
        ...this.searchParams,
      };
      if (!val) {
        searchParams.updateDate = ["", ""];
      }
      this.searchParams = searchParams;
      this.getAllMenuList();
    },
    // 新增
    handleAdd() {
      this.editData = {};
      this.$refs.createMenuRef.open();
    },
    // 编辑
    handleEdit(row) {
      console.log("编辑", row);
      this.editData = row;
      this.$refs.createMenuRef.open();
    },
    // 删除  ---单个删除
    handleDelete(row) {
      console.log("删除", row);
      this.deleteData = row;
      this.$refs.deleteConfirmDialog.open();
      // this.dialogVisible =true
    },
    // api---删除组
    async menuDelete() {
      console.log("delete menu ");
      const params = {
        menuId: this.deleteData.menuId,
      };
      physicalDeleteMenu(params).then((res) => {
        console.log(res);
        if (res.data.code == 1) {
          this.$message.success(this.$t("devices.deleteSuccess"));
          this.deleteData = {};
          this.$refs.deleteConfirmDialog.close();
          this.getAllMenuList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.systemManage-user-group ::v-deep {
  .el-table
    .el-table__fixed-header-wrapper
    .el-table__header
    .is-group
    tr:nth-of-type(2)
    th:nth-of-type(1)
    .cell {
    display: none;
  }
}
</style>